import React from 'react'
import Container from 'react-bootstrap/Container'

const Home: React.FC = () => {
  return (
    <Container className='p-3'>
      <h1>Home</h1>
    </Container>
  )
}

export { Home }
